/* eslint eol-last: ["error", "never"] */
export default {
    loading: false,
    loadingDownload2: false,
    loadingDocumento: false,
    loadingForm: false,
    loadingFormSave: false,
    loadingInterv: false,
    loadingIntervSave: false,
    loadingInterm: false,
    loadingIntermSave: false,
    loadingDownload: false,
    loadingOfertas: false,
    loadingEntrevistas: false,
    registerlist: true,
    registeradd: false,
    registros: [],
    formaciones: [],
    intervenciones: [],
    intermediaciones: [],
    entrevistas: [],
}